<template>
    <div class="analysis is-alway-shadow leader-tab">
        <el-tabs type="card" v-model="tabVal" @tab-click="handleTabClick">
            <el-tab-pane label="月报" name="month"></el-tab-pane>
            <el-tab-pane label="年报" name="year"></el-tab-pane>
        </el-tabs>
        <div class="search_cont">
            <el-form label-width="60px" :inline="true" class="form leader-style-form">
                <el-date-picker v-model="time" type="month" :clearable="false" placeholder="选择月" value-format="yyyy-MM" :picker-options="pickerOptions" v-show="tabVal === 'month'"></el-date-picker>
                <el-date-picker v-model="time" type="year" placeholder="选择年" format="yyyy" value-format="yyyy" :clearable="false" :picker-options="pickerOptions" v-show="tabVal === 'year'"></el-date-picker>
                <div class="button-group">
                    <el-button class="leader-common-button" size="medium" @click="forwardTimeClick">
                        上一{{ tabVal === "month" ? "月" : "年" }}
                    </el-button>
                    <el-button class="leader-common-button" size="medium" @click="nextTimeClick">
                        下一{{  tabVal === "month" ? "月" : "年" }}
                    </el-button>
                </div>
            </el-form>
            <div style="margin-right:10px;">
                <el-button class="leader-common-button" size="medium" v-show="tabVal === 'month'" @click="handleAdd">新增</el-button>
                <el-button class="leader-common-button" size="medium" v-show="tabVal === 'month'">修改</el-button>
                <el-button class="leader-common-button" size="medium">导出</el-button>
            </div>
        </div>
        <div class="table_cont-wrap">
            <el-table border height="100%" class="leader-style-table" :data="tableData" :span-method="objectSpanMethod">
                <el-table-column align="center" label="用能项" width="100" property="category"></el-table-column>
                <el-table-column align="center" label="单位" width="100" property="unit"></el-table-column>
                <el-table-column align="center" label="总耗能" >
                    <el-table-column align="center" label="总能耗" property="z_nh"></el-table-column>
                    <el-table-column align="center" label="标准煤C(吨)" property="z_bm"></el-table-column>
                    <el-table-column align="center" label="C(吨)" property="z_c"></el-table-column>
                    <el-table-column align="center" label="CO2(吨)" property="z_co2"></el-table-column>
                </el-table-column>
                <el-table-column align="center" label="生产" >
                    <el-table-column align="center" label="能耗" property="sc_nh"></el-table-column>
                    <el-table-column align="center" label="标准煤C(吨)" property="sc_bm"></el-table-column>
                </el-table-column>
                <el-table-column align="center" label="空调" >
                    <el-table-column align="center" label="能耗" property="kt_nh"></el-table-column>
                    <el-table-column align="center" label="标准煤C(吨)" property="kt_bm"></el-table-column>
                </el-table-column>
                <el-table-column align="center" label="照明" >
                    <el-table-column align="center" label="能耗" property="zm_nh"></el-table-column>
                    <el-table-column align="center" label="标准煤C(吨)" property="zm_bm"></el-table-column>
                </el-table-column>
                <el-table-column align="center" label="辅助生产" >
                    <el-table-column align="center" label="能耗" property="fzsc_nh"></el-table-column>
                    <el-table-column align="center" label="标准煤C(吨)" property="fzsc_bm"></el-table-column>
                </el-table-column>
            </el-table>
        </div>
        <el-dialog title="新增" width="80%" :visible.sync="dialogStatus" class="leader-dialog">
            <div class="rootDialog">
                <el-form label-width="60px" ref="concentratorRef" :inline="true" style="text-align: left" class="leader-style-form">
                    <el-form-item label="月份: " label-width="60px" prop="target_month" :show-message="false">
                        <el-date-picker v-model="addMonth" align="left" type="month" :clearable="true" placeholder="选择月份" value-format="yyyy-MM" />
                    </el-form-item>
                </el-form>
                <div class="factor">
                    <el-table border height="100%" class="leader-style-table" :data="factorData">
                        <el-table-column align="center" label="电力">
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.electricity"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="汽油">
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.gasoline"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="柴油">
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.oil"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="天然气" >
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.gas"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="水">
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.water"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="C">
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.carbon"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="CO2">
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.co2"></el-input>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div>
                    <el-table border height="100%" class="leader-style-table" :data="electricData" :span-method="objectSpanMethod">
                        <el-table-column align="center" label="用能项" property="category"></el-table-column>
                        <el-table-column align="center" label="单位" property="unit"></el-table-column>
                        <el-table-column align="center" label="总耗能" >
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.z_nh"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="生产" >
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.sc_nh"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="空调" >
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.kt_nh"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="照明" >
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.zm_nh"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="辅助生产" >
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.fzsc_nh"></el-input>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="footer">
                    <el-button type="primary" class="leader-common-button">保存</el-button>
                    <el-button class="leader-common-button" @click="dialogStatus = false">取消</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import dayjs from "dayjs";
import moment from "moment";
export default {
    data() {
        return {
            time: dayjs().format('YYYY-MM'),
            addMonth: dayjs().format('YYYY-MM'),
            tabVal: "month",
            tableData: [],
            dialogStatus: false,
            factorData: [],
            electricData: []
        }
    },
    methods: {
        handleAdd() {
            this.dialogStatus = true;
        },
        handleTabClick(tab, event) {
            if (tab.name === "month") {
                this.time = dayjs().format('YYYY-MM');
            } else if (tab.name === "year") {
                this.time = dayjs().format('YYYY');
            }
        },
        nextTimeClick() {
            if (this.tabVal === "month") {
                this.time = moment(new Date(this.time)).add(1, "months").format("YYYY-MM");
            } else {
                this.time = moment(new Date(this.time)).add(1, "years").format("YYYY");
            }
        },
        /**
         * 上一日、上一月、上一年点击
         */
        forwardTimeClick() {
            if (this.tabVal === "month") {
                this.time = moment(new Date(this.time)).subtract(1, "months").format("YYYY-MM");
            } else {
                this.time = moment(new Date(this.time)).subtract(1, "years").format("YYYY");
            }
        },
        objectSpanMethod({ row, column,rowIndex, columnIndex }) {
            if (rowIndex === 5) {
                if(columnIndex === 0) {
                    return [1,2]
                } else if (columnIndex === 1) {
                    return [0,0]
                }
                
            }
        },
    },
    mounted() {
        this.tableData = [
            {category: '电',unit: 'W.Kw/h',z_nh: 5000,z_bm: 114,z_c:174,z_co2:654,sc_nh:4900,sc_bm:34,kt_nh:3300,kt_bm:114,zm_nh:3300,zm_bm:114,fzsc_nh:330,fzsc_bm:114},
            {category: '汽油',unit: '吨',z_nh: 5000,z_bm: 114,z_c:174,z_co2:654,sc_nh:4900,sc_bm:34,kt_nh:3300,kt_bm:114,zm_nh:3300,zm_bm:114,fzsc_nh:330,fzsc_bm:114},
            {category: '柴油',unit: '吨',z_nh: 5000,z_bm: 114,z_c:174,z_co2:654,sc_nh:4900,sc_bm:34,kt_nh:3300,kt_bm:114,zm_nh:3300,zm_bm:114,fzsc_nh:330,fzsc_bm:114},
            {category: '天然气',unit: '吨',z_nh: 5000,z_bm: 114,z_c:174,z_co2:654,sc_nh:4900,sc_bm:34,kt_nh:3300,kt_bm:114,zm_nh:3300,zm_bm:114,fzsc_nh:330,fzsc_bm:114},
            {category: '水',unit: 'K.T',z_nh: 5000,z_bm: 114,z_c:174,z_co2:654,sc_nh:4900,sc_bm:34,kt_nh:3300,kt_bm:114,zm_nh:3300,zm_bm:114,fzsc_nh:330,fzsc_bm:114},
            {category: '合计',unit: '合计',z_nh: 5000,z_bm: 114,z_c:174,z_co2:654,sc_nh:4900,sc_bm:34,kt_nh:3300,kt_bm:114,zm_nh:3300,zm_bm:114,fzsc_nh:330,fzsc_bm:114},
        ];
        this.factorData = [
            {electricity: 1.2290,gasoline: 1.4714,oil: 1.4571,gas: 1.2140,water: 0,carbon: 0.680,co2: 2.493}
        ];
        this.electricData = [
            {category: '电',unit: 'W.Kw/h',z_nh: 5000,sc_nh:4900,kt_nh:3300,zm_nh:3300,fzsc_nh:330},
            {category: '汽油',unit: '吨',z_nh: 5000,sc_nh:4900,kt_nh:3300,zm_nh:3300,fzsc_nh:330},
            {category: '柴油',unit: '吨',z_nh: 5000,sc_nh:4900,kt_nh:3300,zm_nh:3300,fzsc_nh:330,},
            {category: '天然气',unit: '吨',z_nh: 5000,sc_nh:4900,kt_nh:3300,zm_nh:3300,fzsc_nh:330},
            {category: '水',unit: 'K.T',z_nh: 5000,sc_nh:4900,kt_nh:3300,zm_nh:3300,fzsc_nh:330},
            {category: '合计',unit: '合计',z_nh: 5000,sc_nh:4900,kt_nh:3300,zm_nh:3300,fzsc_nh:330},
        ];
    }

};
</script>

<style scoped lang="scss">
.analysis {
    width: 99%;
    height: 100%;
    display: flex;
    flex-direction: column;
    //border: 1px solid red;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
    border-radius: px2Rem(5px);
    box-sizing: border-box;
    padding: 20px;
    transition: width 500ms;
    .el-tabs--card {
        margin: 0;
    }

    .search_cont {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        .form {
            display: flex;
            justify-content: space-between;
        }
    }

    .table_cont-wrap {
        width: 100%;
        box-sizing: border-box;
        overflow: hidden;
        //height: 100%;
        height: calc(100% - 15px);
        //border: 1px solid red;
    }

    .rootDialog {
        display: flex;
        flex-direction: column;
        .factor {
            margin-bottom: 20px;
        }
        .footer {
            display: flex;
            justify-content: center;
            margin-top: 30px;
        }
    }
}
</style>